import axios from "axios";
import Cookies from "js-cookie";
import store from "@/store";
import router from "@/router";
import i18n from "@/i18n";

const BASE_URL = process.env.VUE_APP_API_PROD_URL;

const http = axios.create({
  baseURL: BASE_URL,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const currentLanguage = Cookies.get("zk_lng") || "ru";
  const token = Cookies.get("authToken");

  config.baseURL = `${BASE_URL}/${currentLanguage}`;

  if (token) {
    config.headers["X-Auth"] = `Bearer ${token}`;
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response?.status === 401) {
      console.warn("Токен недействителен или истёк");
      
      try {
        store.commit("auth/LOGOUT");
      } catch (e) {
        console.error("Ошибка при LOGOUT:", e);
        Cookies.remove("authToken");
      }

      setTimeout(() => {
        try {
          if (router.currentRoute.path !== "/login") {
            router.push("/login");
          }
        } catch (e) {
          console.error("Ошибка при перенаправлении:", e);
          window.location.href = "/login";
        }
      }, 300);
    }

    return Promise.reject(error);
  }
);

export default http;
